import https from "../api/fetch";
import vuex from "../store/store";
import vuexAnalysis from "../analysis/store/index";
var http = https.http;
http.get("./api/user/getCase").then(function (res) {
    vuex.commit("setCasePattern", res.data.data);
    vuexAnalysis.commit("setCasePattern", res.data.data);
});
